import Constants from '../constants'

export default {
   CHANNEL_URL:       Constants.BASE_URL + '/_channels/chan',
   CHANNEL_IO_URL:    Constants.BASE_URL + '/_channels/io',
   CHANNEL_TOKEN_URL: Constants.BASE_URL + '/_channels/token'
}

export const Actions = {
   create: 'channel:create',
   update: 'channel:update',
   list:   'channel:list',
   change: 'channel:change',

   io_recv: 'channel:io:recv',
   io_send: 'channel:io:send',

   token_create: 'channel:token:create',
   token_list:   'channel:token:list',
   token_revoke: 'channel:token:revoke',
   token_change: 'channel:token:change'
}



// WEBPACK FOOTER //
// lib/api/channel/Constants.js